import { apiClient as api } from "./api_helper";

import * as url from "./url_helper";

export const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

export const postJwtProfile = (data) =>
  api.create(url.POST_EDIT_JWT_PROFILE, data);

export const postJwtRegister = async (user) => {
  try {
    return await api.createUser(url.POST_REGISTER, user);
  } catch (error) {
    let message;

    if (error instanceof Response) {
      switch (error.status) {
        case 400:
          message = "Invalid request. Please check your input.";
          break;
        case 401:
          message = "Invalid credentials. Please try again.";
          break;
        case 404:
          message = "Sorry! The page you are looking for could not be found.";
          break;
        case 500:
          message =
            "Sorry! Something went wrong. Please contact our support team.";
          break;
        default:
          message = "An unexpected error occurred. Please try again.";
          break;
      }

      try {
        const errorData = await error.json();
        console.error("Error Response Data:", errorData);
        message =
          Array.isArray(errorData) && errorData.length > 0
            ? errorData[0]
            : message;
      } catch (e) {
        console.error("Failed to parse error response:", e);
      }
    } else if (error instanceof Error) {
      message = error.message || "Request setup error. Please try again.";
    } else {
      message = "An unexpected error occurred. Please try again.";
    }

    console.error("Registration Failed:", message);
    throw message;
  }
};

export const addNewUser = (data) => api.create(`${url.ADD_NEW_USER}`, data);

// Login Method
export const postJwtLogin = (data) => api.create(url.POST_FAKE_JWT_LOGIN, data);

// postForgetPwd
export const postJwtForgetPwd = (data) =>
  api.create(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

// postSocialLogin
export const postSocialLogin = (data) => api.create(url.SOCIAL_LOGIN, data);

//get Invoice
export const getInvoices = () => api.get(url.GET_INVOICES);

// add Invoice
export const addNewInvoice = (invoice) =>
  api.create(url.ADD_NEW_INVOICE, invoice);

// update Invoice
export const updateInvoice = (invoice) =>
  api.update(url.UPDATE_INVOICE + invoice._id, invoice);

// delete Invoice
export const deleteInvoice = (invoice) =>
  api.delete(url.DELETE_INVOICE + invoice);

// Blocks
export const getBlocks = () => {
  return api.get(url.GET_BLOCKS, {});
};

// Add New Block
export const addNewBlock = (block) => {
  return api.create(`${url.ADD_NEW_BLOCK}/`, block);
};

export const getBlockById = (id) => {
  return api.get(`${url.GET_BLOCK_BY_ID}/${id}`, {});
};

export const getBlockUnitsById = (id) => {
  return api.get(`${url.GET_BLOCK_BY_ID}/${id}/units`, {});
};

// Update Block
export const updateBlock = (block) => {
  return api.update(`${url.UPDATE_BLOCK}/${block.id}/`, block);
};

// Delete Block
export const deleteBlock = (block) => {
  return api.delete(`${url.DELETE_BLOCK}/${block}`);
};

// Clients
export const getClients = (queryParams) => {
  return api.get(`${url.GET_CLIENTS}/`, { params: queryParams });
};

export const getClientsOverdue = () => {
  return api.get(`${url.GET_CLIENTS_OVERDUE}/`, {});
};

export const getClientStats = (queryParams) => {
  return api.get(`${url.GET_CLIENT_STATS}/`, { params: queryParams });
};

// Get Client by ID
export const getClientById = (id) => {
  return api.get(`${url.GET_CLIENT_BY_ID}/${id}`, {});
};

export const getClientDetails = (id) => {
  return api.get(`${url.GET_CLIENT_BY_ID}/${id}/get_client_details`, {});
};

export const getClientUnitsById = (id) => {
  return api.get(`${url.GET_CLIENT_BY_ID}/${id}/get_units`, {});
};

export const getAvailableContacts = async (id) => {
  return api.get(`${url.GET_AVAILABLE_CONTACTS}/${id}/available-contacts`, {});
};

export const addNewClient = (client) => {
  return api.create(`${url.ADD_NEW_CLIENT}/`, client);
};

export const updateClient = (client) => {
  return api.update(`${url.UPDATE_CLIENT}/${client.id}/`, client);
};

export const deleteClient = (id) => {
  return api.delete(`${url.DELETE_CLIENT}/${id}/`);
};

// Contracts
export const getContracts = (queryParams) => {
  return api.get(`${url.GET_CONTRACTS}/`, { params: queryParams });
};

export const getContractStats = (queryParams) => {
  return api.get(`${url.GET_CONTRACT_STATS}/`, { params: queryParams });
};

// Get Contract by ID
export const getContractById = (id) => {
  return api.get(`${url.GET_CONTRACT_BY_ID}/${id}/`, {});
};

export const getContractByIdFull = (id) => {
  return api.get(`${url.GET_CONTRACT_BY_ID}/${id}/`, {});
};

export const addNewContract = (contract) => {
  return api.create(`${url.ADD_NEW_CONTRACT}/`, contract);
};

export const createContract = (contract) => {
  return api.create(`${url.CREATE_CONTRACT}/`, contract)
}

export const updateContract = (contract) => {
  return api.update(`${url.UPDATE_CONTRACT}/${contract.id}/`, contract);
};

export const updateContractFinancials = (contractId, payload) => {
  return api.put(`${url.UPDATE_CONTRACT}/${contractId}/financials/`, payload);
};

export const deleteContract = (contract) => {
  return api.delete(`${url.DELETE_CONTRACT}/${contract}/`);
};

// Payments
export const getPayments = (queryParams) => {
  return api.get(`${url.GET_PAYMENTS}/`, { params: queryParams });
};

// Get Payment by ID
export const getPaymentById = (id) => {
  return api.get(`${url.GET_PAYMENT_BY_ID}/${id}/`, {});
};

export const addNewPayment = (payment) => {
  return api.create(`${url.ADD_NEW_PAYMENT}/`, payment);
};

export const addNewPaymentBulk = (payment) => {
  return api.create(`${url.ADD_NEW_PAYMENT_BULK}/`, payment);
};

export const updatePaymentBulk = (payments) => {
  return api.put(`${url.UPDATE_PAYMENT_BULK}/`, payments);
};

export const updatePayment = (payment) => {
  return api.update(`${url.UPDATE_PAYMENT}/${payment.id}/`, payment);
};

export const deletePayment = (payment) => {
  return api.delete(`${url.DELETE_PAYMENT}/${payment}/`);
};

// Settlement Prices
export const getSettlementPrices = (queryParams) => {
  return api.get(`${url.GET_SETTLEMENT_PRICES}/`, { params: queryParams });
};

export const getSettlementPriceById = (id) => {
  return api.get(`${url.GET_SETTLEMENT_PRICE_BY_ID}/${id}/`, {});
};

export const addNewSettlementPrice = (settlementPrice) => {
  return api.create(`${url.ADD_NEW_SETTLEMENT_PRICE}/`, settlementPrice);
};

export const updateSettlementPrice = (settlementPrice) => {
  return api.update(
    `${url.UPDATE_SETTLEMENT_PRICE}/${settlementPrice.id}/`,
    settlementPrice
  );
};

export const deleteSettlementPrice = (settlementPrice) => {
  return api.delete(`${url.DELETE_SETTLEMENT_PRICE}/${settlementPrice}/`);
};

// Units
export const getUnits = (queryParams) => {
  return api.get(`${url.GET_UNITS}/`, { params: queryParams });
};

// Get Unit by ID
export const getUnitById = (id) => {
  return api.get(`${url.GET_UNIT_BY_ID}/${id}/`, {}); // Add the GET_BY_ID endpoint for Unit
};

export const getUnitsByBlock = (id) => {
  return api.get(`${url.GET_UNITS}/`, { params: { block: id, all: true } });
};

export const addNewUnit = (unit) => {
  return api.create(`${url.ADD_NEW_UNIT}/`, unit);
};

export const updateUnit = (unit) => {
  return api.update(`${url.UPDATE_UNIT}/${unit.id}/`, unit);
};

export const deleteUnit = (unit) => {
  return api.delete(`${url.DELETE_UNIT}/${unit}/`);
};

// Projects
export const getProjects = () => {
  return api.get(`${url.GET_PROJECTS}/`, {});
};

// Get Project by ID
export const getProjectById = (id) => {
  return api.get(`${url.GET_PROJECT_BY_ID}/${id}/`, {});
};

export const addNewProject = (project) => {
  return api.create(`${url.ADD_NEW_PROJECT}/`, project);
};

export const updateProject = (project) => {
  return api.update(`${url.UPDATE_PROJECT}/${project.id}/`, project);
};

export const deleteProject = (project) => {
  return api.delete(`${url.DELETE_PROJECT}/${project}/`);
};

export const getProjectPhasesById = (id) => {
  return api.get(`${url.GET_PROJECT_BY_ID}/${id}/phases/`, {});
};

// Phases
export const getPhases = () => {
  return api.get(`${url.GET_PHASES}/`, {});
};

// Get Phase by ID
export const getPhaseById = (id) => {
  return api.get(`${url.GET_PHASE_BY_ID}/${id}`, {});
};

// Get Phase blocks by ID
export const getPhaseBlockById = (id) => {
  return api.get(`${url.GET_PHASE_BY_ID}/${id}/blocks/`, {});
};

export const addNewPhase = (phase) => {
  return api.create(`${url.ADD_NEW_PHASE}/`, phase);
};

export const updatePhase = (phase) => {
  return api.update(`${url.UPDATE_PHASE}/${phase.id}/`, phase);
};

export const deletePhase = (phase) => {
  return api.delete(`${url.DELETE_PHASE}/${phase}/`);
};

export const getUsers = () => {
  return api.get(`${url.GET_USERS}/`);
};

export const getUser = (queryParams) => {
  return api.get(`${url.GET_USER}`, { params: queryParams });
};

export const getUserProfile = () => {
  return api.get(`${url.GET_USER_PROFILE}`);
};

export const updateUserProfile = (user) => {
  return api.put(`${url.UPDATE_USER_PROFILE}`, user);
};

export const updateUser = (user) => {
  return api.put(`${url.UPDATE_USER}/${user.id}/`, user);
};

export const deleteUser = (userId) => {
  return api.delete(`${url.DELETE_USER}/${userId}/`);
};

export const changeUserPassword = (passwordDetails) => {
  return api.create(url.CHANGE_USER_PASSWORD, passwordDetails);
};

export const changeUserPasswordAdmin = (userId, passwordDetails) => {
  return api.create(
    `${url.CHANGE_USER_PASSWORD_ADMIN}/${userId}/`,
    passwordDetails
  );
};

export const getReportProject = (id) => {
  return api.get(`${url.GET_REPORT_PROJECT}/${id}/`);
};

export const getDocuments = (queryParams) => {
  return api.get(`${url.GET_DOCUMENT}/`, { params: queryParams });
};

export const getDownloadDocument = (id) => {
  return api.get(`${url.GET_DOCUMENT}/${id}/download_url`);
};

export const getViewPDF = (id) => {
  return api.get(`${url.GET_DOCUMENT}/${id}/view_pdf/`, {
    responseType: "blob",
  });
};

export const addDocument = (data) => {
  return api.createFormData(`${url.GET_DOCUMENT}/`, data);
};

export const updateDocument = (data) => {
  return api.put(`${url.UPDATE_DOCUMENT}/${data.id}/`, data);
};

export const deleteDocument = (id) => {
  return api.delete(`${url.DELETE_DOCUMENT}/${id}/`);
};

//Email
export const sendOverdueEmailApi = async (emailData) => {
  try {
    const response = await api.createMail(`${url.SEND_OVERDUE_EMAIL}`, emailData);
    return response;
  } catch (error) {

    if (error) {
      const status = error.status;
      const message = error.message || "An error occurred";

      throw { status, message }; // Return structured error
    }

    throw { status: 500, message: "Unknown error" };
  }
};

export const sendReminderEmailApi = async (emailData) => {
  try {
    const response = await api.createMail(`${url.SEND_REMINDER_EMAIL}`, emailData);
    return response;
  } catch (error) {
    console.error("Reminder email error:", error);

    if (error) {
      const status = error.status;
      const message = error.message || "An error occurred";

      throw { status, message }; // Return structured error
    }

    throw { status: 500, message: "Unknown error" };
  }
};

export const extractDocument = (data) => {
  return api.createFormData(`${url.EXTRACT_DOCUMENT}/`, data);
};
